import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import BtnCellRenderer from "../../common/BtnCellRenderer";
import { useHistory } from "react-router-dom";

import { insuranceActions } from "../../../core/actions";

import { patientActions } from "../../../core/actions";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { InputAdornment, IconButton, Typography } from "@mui/material"; // 👈 Add Typography here
import DialogActions from "@mui/material/DialogActions"; // 👈 Add this

function TpaGrid(props) {
  let ids;
  const history = useHistory();
  const [pagination, setPagination] = useState(true);
  const [paginationPageSize, setPaginationPageSize] = useState(10);
  const [insuranceForm, setInsuranceData] = useState(false);
  const [insuranceRowData, setinsuranceRowData] = useState({});
  const [insuranceRowlist, setRowData] = useState();

  const dispatch = useDispatch();
  const [tpaDetail, setTpaDetail] = useState({
    id: "",
    companyName: "",
    address: "",
    email: "",
    phone1: "",
    phone2: "",
    description: "",
  });
  const [confirm, setConfirm] = useState(false);
  const [onmodal, setOnModal] = useState(true);
  const closemodalopen = () => {
    setOnModal(true);
  };

  const getAggriddata = (e) => {
    console.log("props", props);
    console.log("getAggriddata", e.data);

    if (e.colDef.field == "Actions") {
      setConfirm(!confirm);
      console.log("delete rowdata:", e.data);
      setTimeout(() => {
        setTpaDetail(e.data);
        console.log("tpaDetail", tpaDetail);
      }, 1000);
      console.log("tpaDetail", tpaDetail);
    } else {
      history.push("/tpamaster", {
        rowData: e.data,
        label: "edit",
      });
    }
  };
  const customComparator = (valueA, valueB) => {
    return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
  };

  const [columnDefs] = useState([
    {
      headerName: "Company Name ",
      field: "companyName",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      comparator: customComparator,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Email",
      field: "email",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Contact 1",
      field: "phone1",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      onGridReady: "open",
      headerClass: "ag-header-left",
    },
    {
      headerName: "Contact 2",
      field: "phone2",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      headerClass: "ag-header-left",
    },
    {
      headerName: "Description.",
      field: "description",

      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      floatingFilter: true,
      comparator: customComparator,
      headerClass: "ag-header-left",
      // onCellClicked:getAggriddata(e)
    },
    {
      headerName: "Actions",
      field: "Actions",
      sortable: true,
      filter: true,
      flex: 1,
      resizable: true,
      width: 150,
      cellRenderer: "BtnCellRenderer",
      headerClass: "ag-header-left",
    },
  ]);

  const visitsList = useSelector(
    (state) => state.patientDetailsState.visitsList
  );

  useEffect(() => {
    dispatch(patientActions.setPageHeader("tpa"));

    let data = {};
    console.log("props are:", props.tpamaster);
    if (props && props.tpamaster && props.tpamaster.length > 0) {
      let pslist = props.tpamaster;
      for (let item of pslist) {
        setRowData(pslist);
      }
    } else {
      console.log("no prop");
      setRowData(tpaDetail);
    }
  }, [props]);

  const handleSubmit = (event) => {
    console.log("event", event);
    console.log("tpaDetail", tpaDetail);
    dispatch(
      insuranceActions.deleteTpa(tpaDetail, (resCb) => {
        if (resCb) {
          console.log("deleteTpa", resCb);
          // props.history.push("/tpamasterlist");
          setConfirm(!confirm);
          props.onGridAction("Third party data deleted successfully");
        }
      })
    );
  };
  const toggle = (event) => {
    setConfirm(!confirm);
  };

  const rowStyle = { background: "white" };

  return (
    <>
      {/* <h5 className="page-title my-2 mx-3">Doctors</h5> */}
      <div>
        <div className="p-0 preview">
          <div
            className="ag-theme-balham ag-style card rounded table mb-0 tcol"
            style={{ height: 500, width: `98%` }}
          >
            <AgGridReact
              frameworkComponents={{ BtnCellRenderer: BtnCellRenderer }}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              //   context={context}
              rowData={insuranceRowlist}
              columnDefs={columnDefs}
              // onRowClicked={(e) => getAggriddata(e)}
              rowStyle={rowStyle}
              //   getRowStyle={getRowStyle}

              onCellClicked={(e) => {
                console.log("event onCellclicked::", e);
                const field = e.colDef.field;
                const colIndex = e.columnApi
                  .getAllColumns()
                  ?.findIndex((col) => col.getColDef().field === field);

                console.log("cell clicked ", field, colIndex);
                getAggriddata(e);
              }}
            ></AgGridReact>
          </div>
          {confirm && (
            <div>
              <Dialog
                open={confirm}
                onClose={toggle}
                aria-labelledby="confirm-dialog-title"
                fullWidth
                maxWidth="sm" // or "xs" for smaller
                scroll="paper"
                PaperProps={{
                  sx: {
                    borderRadius: 2,
                    margin: { xs: 1, sm: 2 }, // responsive margin
                    width: "100%",
                  },
                }}
              >
                <DialogTitle
                  id="confirm-dialog-title"
                  sx={{
                    py: 2,
                    px: 3,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  Confirm Operation
                  <IconButton
                    aria-label="close"
                    onClick={toggle}
                    sx={{
                      color: (theme) => theme.palette.grey[500],
                      ml: "auto",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 3, pb: 2 }}>
                  <Typography variant="body1" color="textSecondary">
                    This operation cannot be undone! Do you want to continue?
                  </Typography>
                </DialogContent>

                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button
                    onClick={toggle}
                    variant="outlined"
                    color="inherit"
                    sx={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="error"
                    sx={{ textTransform: "none", ml: 1 }}
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default TpaGrid;
